import Vue from 'vue'
import VueRouter from 'vue-router'
import NoFootLayout from '@/views/NoFootLayout';
import BaseLayout from '@/views/BaseLayout';
import CustomLayout from '@/views/CustomLayout';
import PrivacyDoc from '@/views/mobile/PrivacyDoc';

// hack router push callback
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '404',
    component: CustomLayout,
    redirect: '/404',
    children: [
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/Nofind')
      },
      {
        path: '/testEntry',
        name: 'testEntry',
        component: () => import('@/views/TestEntryView')
      },
      {
        path: '/privacy/doc',
        name: 'privacyDoc',
        component: PrivacyDoc
      },
      {
        path: '/customPage/:id',
        name: 'customPage',
        component: () => import('@/views/CustomPage/CustomPage')
      },
      {
        path: '/privacyAgreement/:appId/:cn',
        name: 'privacyAgreement',
        component: () => import('@/views/CustomPage/PrivacyAgreement')
      },
      {
        path: '/userAgreement/:appId/:cn',
        name: 'userAgreement',
        component: () => import('@/views/CustomPage/UserAgreement')
      }
    ]
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: BaseLayout,
    redirect: '/feedback',
    children: [
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/Feedback/Feedback')
      },
      {
        path: '/robotShow',
        name: 'robotShow',
        component: () => import('@/views/Feedback/RobotShow')
      },
      {
        path: '/complaintList',
        name: 'complaintList',
        component: () => import('@/views/Feedback/ComplaintList')
      }
    ]
  },
  {
    path: '/complaintShow',
    name: 'complaintShow',
    component: NoFootLayout,
    redirect: '/complaintShow',
    children: [
      {
        path: '/complaintAdd',
        name: 'complaintAdd',
        component: () => import('@/views/Feedback/ComplaintAdd')
      },
      {
        path: '/complaintShow',
        name: 'complaintShow',
        component: () => import('@/views/Feedback/ComplaintShow')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router;
